import Swiper from 'swiper/dist/js/swiper.min';

export default class Projects {
  constructor(parent) {
    this.parent = parent;
    const projectItems = [].slice.call(this.parent.querySelectorAll('.projects__item'));
    const mainSliderWrp = this.parent.querySelector('.projects__main-slider');
    const thumbSliderWrp = this.parent.querySelector('.projects__thumb-slider');

    if (projectItems.length > 1) {
      this.thumbSlider = new Swiper(thumbSliderWrp, {
        resistance: true,
        resistanceRatio: 0,
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 12,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        pagination: {
          el: parent.querySelector('.projects__thumb-slider-pagination'),
          clickable: true,
        },
        on: {
          init: false,
        },
        breakpointsInverse: true,
        breakpoints: {
          767: {
            slidesPerView: 4,
            slidesPerGroup: 4,
          },
        },
      });

      const thumbs = this.thumbSlider;

      if ([].slice.call(this.thumbSlider.pagination.bullets).length <= 1) {
        this.thumbSlider.pagination.el.classList.add('projects__thumb-slider-pagination--hide');
      }

      if (mainSliderWrp) {
        this.mainSlider = new Swiper(mainSliderWrp, {
          slidesPerView: 1,
          on: {
            init() {
              const itemActive = [...thumbs.slides].filter(elem => elem.classList.contains('projects__thumb-slide--active'));
              itemActive[0].classList.remove('projects__thumb-slide--active');
              thumbs.slides[this.activeIndex].classList.add('projects__thumb-slide--active');
            },
            slideChange() {
              const itemActive = [...thumbs.slides].filter(elem => elem.classList.contains('projects__thumb-slide--active'));
              itemActive[0].classList.remove('projects__thumb-slide--active');
              thumbs.slides[this.activeIndex].classList.add('projects__thumb-slide--active');
              const projectsContent = [].slice.call(parent.querySelectorAll('.projects__item'));
              if (projectsContent) {
                const activeTab = projectsContent.filter(project => project.classList.contains('projects__item--active'))[0];
                if (activeTab) {
                  activeTab.classList.remove('projects__item--active');
                }
                projectsContent[this.activeIndex].classList.add('projects__item--active');
              }
            },
          },
        });
        this.mainSlider.params.controller.control = this.thumbSlider;
        this.thumbSlider.params.controller.control = this.mainSlider;
      }

      const slides = [...this.thumbSlider.slides];
      slides.forEach((slide, index) => {
        slide.addEventListener('click', (e) => {
          e.preventDefault();
          slides.forEach(el => el.classList.remove('projects__thumb-slide--active'));
          slide.classList.add('projects__thumb-slide--active');

          const activeItem = projectItems.find(el => el.classList.contains('projects__item--active'));
          if (activeItem) {
            activeItem.classList.remove('projects__item--active');
          }
          projectItems[index].classList.add('projects__item--active');
          if (this.mainSlider) {
            this.mainSlider.slideTo(index);
          }
        });
      });

      this.links = [].slice.call(this.parent.querySelectorAll('.projects__item-link'));
      if (this.links) {
        this.links.forEach((link) => {
          link.addEventListener('click', (e) => {
            e.preventDefault();
            this.text = link.previousElementSibling;
            if (this.text) {
              this.text.classList.toggle('projects__item-text--crop');
              if (!this.text.classList.contains('projects__item-text--crop')) {
                link.textContent = 'Скрыть';
              } else {
                link.textContent = 'Читать полностью';
              }
            }
          });
        });
      }
    }
  }
}



// WEBPACK FOOTER //
// ./new-blocks/projects/projects.js